"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dedupeFilenames;

var _parseFilename2 = _interopRequireDefault(require("./parseFilename"));

function dedupeFilenames(array) {
  var nextArray = [];
  array.forEach(function (value) {
    var _parseFilename = (0, _parseFilename2["default"])(value),
        extname = _parseFilename.extname,
        name = _parseFilename.name;

    var count = 0;
    var nextValue = value;

    while (nextArray.includes(nextValue)) {
      nextValue = [name, "(".concat(++count, ")")].filter(function (segment) {
        return segment;
      }).join(' ') + extname;
    }

    nextArray.push(nextValue);
  });
  return nextArray;
}